<template>
  <div class="news-page">
    <THeader />
    <news-item :value="newsData" :main="false" />
  </div>
</template>

<script>
import news from '@/news/index.ts'
import { useRoute } from 'vue-router'
import {computed} from 'vue'
import NewsItem from '@/components/NewsItem'
import THeader from '@/components/THeader'

export default {
  name: 'NewsPage',
  components: {THeader, NewsItem},
  setup() {
    const newsName = computed(() => {
      return useRoute().params.id
    })

    const newsData = computed(() => {
      return news.find(item => item.link === newsName.value)
    })

    return {
      newsName,
      newsData
    }
  }
}
</script>

<style scoped>
@media screen and (max-width: 768px) {

}
</style>
